"use client";

import { Fragment } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import type { PayloadLegalLinksConfig } from "@portal/app/_server/services/formFunnel/payloadTypes";

interface FormFunnelLegalLinksProps {
  config: PayloadLegalLinksConfig;
}

export function FormFunnelLegalLinks({ config }: FormFunnelLegalLinksProps) {
  if (!config.enabled) return null;

  const links = (config.links ?? []).filter((l) => l.label?.trim() && l.url?.trim());

  if (links.length === 0) return null;

  return (
    <Container maxWidth="sm">
      <Box
        data-testid="form-funnel-legal-links"
        sx={{
          mt: 4,
          mb: 2,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        {links.map((link, i) => (
          <Fragment key={link.id ?? `${link.label}-${i}`}>
            {i > 0 && (
              <Typography variant="caption" color="text.secondary" aria-hidden>
                ·
              </Typography>
            )}
            <Link
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              variant="caption"
              color="text.secondary"
              underline="hover"
            >
              {link.label}
            </Link>
          </Fragment>
        ))}
      </Box>
    </Container>
  );
}
